<template>
  <div class="fab-container">
    <transition name="fab-menu">
      <div v-if="menuOpen" class="fab-menu">
        <b-button
          v-if="userAccessStore.access.nfe"
          variant="info"
          pill
          class="fab-item px-8 py-3 my-2"
          @click="$router.push({ name: 'nfeNova' })"
        >
          NFe
        </b-button>
        <b-button
          v-if="userAccessStore.access.vendas"
          variant="info"
          pill
          class="fab-item px-8 py-3 my-2"
          @click="$router.push({ name: 'vendasNovo' })"
        >
          NFCe
        </b-button>
        <b-button
          v-if="userAccessStore.access.orcamento"
          variant="info"
          pill
          class="fab-item px-8 py-3 my-2"
          @click="$router.push({ name: 'orcamentoNovo' })"
        >
          Orçamentos
        </b-button>
        <b-button
          v-if="userAccessStore.access.pedidos"
          variant="info"
          pill
          class="fab-item px-8 py-3 my-2"
          @click="$router.push({ name: 'pedidosNovo' })"
        >
          Pedidos
        </b-button>
        <b-button
          v-if="userAccessStore.access.nfse"
          variant="info"
          pill
          class="fab-item px-8 py-3 my-2"
          @click="$router.push({ name: 'nova-nfseServicos' })"
        >
          NFSe
        </b-button>
        <b-button
          v-if="userAccessStore.access.ordensServicos"
          variant="info"
          pill
          class="fab-item px-8 py-3 my-2"
          @click="$router.push({ name: 'ordensServicosNova' })"
        >
          OS
        </b-button>
      </div>
    </transition>

    <b-button
      variant="primary"
      size="lg"
      class="px-8 py-4"
      pill
      @click="toggleMenu"
    >
      Atalhos
    </b-button>
  </div>
</template>

<script>
import { userAccessStore } from "@/userAccessStore";

export default {
  data() {
    return {
      menuOpen: false,
      userAccessStore,
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
  },
};
</script>

<style scoped>
.fab-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  text-align: right;
}

.fab-menu {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  align-items: flex-end;
}

.fab-item {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

.fab-menu-enter-active,
.fab-menu-leave-active {
  transition: all 0.3s;
}
.fab-menu-enter,
.fab-menu-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
